import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { IncompleteTyresQueryKeys } from "modules/IncompleteTyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Tyre } from "models";

type CompleteTyrePayload = Pick<
  Tyre,
  "id" | "manufacturer" | "description" | "carry_capacity" | "width" | "height" | "size" | "speed" | "season" | "ean" | "run_flat_tire"
>;

export const useCompleteTyreMutation = () =>
  useTypedMutation<CompleteTyrePayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/tyres/incomplete/complete", payload, ENV.carBaseURL);
    },
    onSuccess: payload => {
      const incompleteTyres = typedQueryClient.getQueryData(IncompleteTyresQueryKeys.incompleteTyres);
      if (!incompleteTyres) return;

      const tyreIdx = incompleteTyres.tyres.findIndex(tyre => tyre.id === payload.id);
      if (tyreIdx === -1) return;

      typedQueryClient.setQueryData(IncompleteTyresQueryKeys.incompleteTyres, {
        ...incompleteTyres,
        tyres: incompleteTyres.tyres.toSpliced(tyreIdx, 1),
        nb_items: incompleteTyres.nb_items - 1
      });
    }
  });
